'use client';
import ForfeitModal from '@/app/rewards/components/ForfeitModal/ForfeitModal';
import useUserVerificationLevels from '@/hooks/useUserVerificationLevels/useUserVerificationLevels';
import {
	ModalStatusEnum,
	useForfeitBonusModalId,
	useLogin,
	useModalStatus,
	useModalStoreActions,
	useUser,
} from '@/store';
import dynamic from 'next/dynamic';
import { useEffect, useMemo } from 'react';
import ModalWrapper from './ModalWrapper/ModalWrapper';

const SearchModal = dynamic(() => import('../SearchModal/SearchModal'), {
	ssr: false,
});

const WalletModal = dynamic(() => import('./WalletModal/WalletModal'), {
	ssr: false,
});

const PromoCodeModal = dynamic(
	() => import('@/app/rewards/components/PromoCodeModal/PromoCodeModal'),
	{
		ssr: false,
	}
);

// const GeoBlockModal = dynamic(
// 	() => import('@/app/(home)/components/GeoBlockModal/GeoBlockModal'),
// 	{
// 		ssr: false,
// 	}
// );

const VerificationLevel1 = dynamic(
	() =>
		import(
			'@/features/Onboarding/components/Steps/VerificationLevel1/VerificationLevel1'
		),
	{
		ssr: false,
	}
);
const DepositLimitKYC2Modal = dynamic(
	() =>
		import('@/components/Modals/DepositLimitKYC2Modal/DepositLimitKYC2Modal'),
	{
		ssr: false,
	}
);

const Modals = () => {
	const user = useUser();
	const modalStatus = useModalStatus();
	const login = useLogin();
	const { setModalStatus } = useModalStoreActions();
	const {
		isEmail_verified,
		isVerified_level_1,
		isVerified_level_2,
		isVerified_level_3,
		showVerificationStepsModal,
	} = useUserVerificationLevels();
	const forfeitBonusModalId = useForfeitBonusModalId();
	useEffect(() => {
		if (!user) {
			if (
				modalStatus === ModalStatusEnum.WalletModal ||
				(modalStatus === ModalStatusEnum.RedeemPromoModal && login)
			) {
				if (login) {
					login();
				}
				setModalStatus(null);
			}
		}
	}, [modalStatus, login, user]);

	const modalComponent = useMemo(() => {
		switch (modalStatus) {
			case ModalStatusEnum.SearchModal:
				return <SearchModal />;
			case ModalStatusEnum.RedeemPromoModal:
				return <PromoCodeModal />;

			case ModalStatusEnum.WalletModal:
				return <WalletModal />;

			case ModalStatusEnum.VerificationLevel1:
				return (
					<ModalWrapper onClose={() => {}}>
						<VerificationLevel1 />
					</ModalWrapper>
				);
			case ModalStatusEnum.ForfeitedBonusModal:
				if (!forfeitBonusModalId) return null;
				return (
					<ModalWrapper onClose={() => {}}>
						<ForfeitModal bonusId={forfeitBonusModalId} />
					</ModalWrapper>
				);
			case ModalStatusEnum.DepositLimitKYC2Modal:
				return <DepositLimitKYC2Modal />;
			// case ModalStatusEnum.GeoBlockModal:
			// 	return <GeoBlockModal />;
			default:
				return null;
		}
	}, [modalStatus, showVerificationStepsModal]);

	if (!user) {
		if (modalStatus === ModalStatusEnum.WalletModal) {
			return null;
		}
	}

	return <>{modalComponent}</>;
};

export default Modals;

// 'use client';
// import React, { useMemo } from 'react';
// import dynamic from 'next/dynamic';
// import { ModalStatusEnum, useModalStatus } from '@/store';
// import ModalWrapper from './ModalWrapper/ModalWrapper';

// const SearchModal = dynamic(() => import('../SearchModal/SearchModal'), {
// 	ssr: false,
// });

// const WalletModal = dynamic(() => import('./WalletModal/WalletModal'), {
// 	ssr: false,
// });

// const RedeemCodeModal = dynamic(
// 	() => import('@/app/rewards-old/components/RedeemCodeModal/RedeemCodeModal'),
// 	{
// 		ssr: false,
// 	}
// );

// const VerificationLevel1= dynamic(
// 	() =>
// 		import('@/features/Onboarding/components/Steps/VerificationLevel1/VerificationLevel1'),
// 	{
// 		ssr: false,
// 	}

// const Modals = () => {
// 	const modalStatus = useModalStatus();

// 	const modalComponent = useMemo(() => {
// 		switch (modalStatus) {
// 			case ModalStatusEnum.SearchModal:
// 				return <SearchModal />;
// 			case ModalStatusEnum.RedeemPromoModal:
// 				return <RedeemCodeModal />;
// 			case ModalStatusEnum.WalletModal:
// 				return <WalletModal />;
// 				case ModalStatusEnum.VerificationLevel1:
// 					return (
// 					<ModalWrapper onClose={()=>{}}>
// 					<VerificationLevel1 />
// 					</ModalWrapper>
// 					);
// 			default:
// 				return null;
// 		}
// 	}, [modalStatus]);

// 	return <>{modalComponent}</>;
// };

// export default Modals;
